export enum StoreKey {
  AUTHENTICATED_USER = 'AUTHENTICATED_USER',
  ACCESS_TOKEN = 'access_token',
  REFRESH_TOKEN = 'refresh_token',
  MOBILE_STATUS_SCREEN = 'mobile_status_screen',
}
